<template>

  <b-tab title-item-class="tab-title"  @click="onTabChange">

      <template slot="title">
          {{ collection_title }} 
          <span v-if="!offline">
            <span v-if="in_progress == false">
                ({{ interactions[collection_name].length }} interaction<span v-if="interactions[collection_name].length > 1">s</span>)
            </span>
          </span>
      </template>

      <b-card-text>

          <div v-if="!offline">

            <div v-if="in_progress" class="progress-container">
              <PulseLoader :color="theme_color.main"/>
            </div>

            <div v-else class="content-container">

              <FacetsComponent class="facets-container" :collection_name="collection_name" :documents="interactions[collection_name]" :filters="filters.interactions" :user_selection="user_selection.interactions" :item_size="3" :updateFacet="updateInteractionsFacet" :updateSort="updateInteractionsSort"/>

              <div class="full-container">

                <div class="active-filters-container">
                    <span class="filter-name" v-for="filter in activeFilters" :key="filter.name" >
                      <span class="filter-remove" @click="removeFilter(filter.type, filter.name)">x </span> {{ filter.name }}
                    </span>
                    <span class="filters-remove" v-if="activeFilters.length > 1">
                      <span @click="removeAllFilters">Remove all filters</span>
                    </span>
                </div>

                <ResultsInteractions :interactions="interactions[collection_name]" :collection_name="collection_name" :collection_title="collection_title"/>
            
              </div> 

            </div>

          </div>

          <div v-else>

            <p>We are updating this collection. Please check back later. Thank you for your patience!</p>

          </div>

          

      </b-card-text>

  </b-tab>

</template>

<script>

  import { mapState, mapActions } from 'vuex'
  import axios from 'axios';
  import FacetsComponent from '@/components/FacetsComponent.vue'
  import ResultsInteractions from '@/components/ResultsInteractions.vue'
  var PulseLoader = require('vue-spinner/src/PulseLoader.vue').default;

  export default {
    name: 'ResultsCollection',
    components: {
      PulseLoader,
      FacetsComponent,
      ResultsInteractions,
    },
    props: {
      collection_name: {
          type: String,
          required: true
      },
      collection_title: {
          type: String,
          required: true
      },
      offline:  {
        type: Boolean,
        default: false
      }
    },
    data() {
        return {
          in_progress: false,
        };
      },
    computed: {
      ...mapState(['urls', 'user_query', 'interactions', 'user_selection', 'filters', 'theme_color']),
      cssVars () {
        return{
           '--color-main': this.theme_color.main,
        }
      },
      activeFilters(){
          var actived_filters = []
          for (const key in this.user_selection.interactions.facets) {
              var list = this.user_selection.interactions.facets[key]
              if (key != "date"){
                  for (var i=0; i<list.length; i++){
                      var item = {}
                      item.name = list[i]
                      item.type = key
                      actived_filters.push(item)
                  }
              }
          }
          return actived_filters;
      },
    },
    methods: {
      ...mapActions(['updateResults', 'updateInteractionsFacet', 'updateInteractionsSort']),
      onTabChange(){
        this.$matomo?.trackEvent("Display collection", this.collection_name);
      },
      search(){
        this.in_progress = true
        this.updateResults({'collection': this.collection_name, 'interactions': []})
        var url_search = this.urls.search
        var url = url_search+"?collection="+this.collection_name
            if (this.user_query.interaction != "none" && this.user_query.interaction != ""){
                url += "&interaction="+this.user_query.interaction_id
            }
            if (this.user_query.taxon1 != ""){
              url += "&taxon1="+this.user_query.taxon1_id
            }
            if (this.user_query.taxon2 != ""){
              url += "&taxon2="+this.user_query.taxon2_id
            }
           url += "&gui"
        axios
            .get(url)
            .then(response => {
              var documents = response.data
              this.$matomo?.trackEvent("Results count for "+this.collection_name, documents.length+" documents");
              documents.sort((a, b) => parseFloat(b.score) - parseFloat(a.score));
              documents = this.processFacets(documents)
              this.updateResults({'collection': this.collection_name, 'interactions': documents})
            })
            .catch(error => {
              alert ("Failed to search biotic interactions: "+error)
            })
            .finally(() => this.in_progress = false)
      },
      processFacets(interactions){
        for (var v = 0; v < interactions.length; v++ ) {

              interactions[v].rank = v
              if (interactions[v]["interaction"] == "none"){
                  interactions[v]["interaction"] = {"preferred_term": "None"}
              }
              var processed_facets = {}
              
              var document = interactions[v]
              for (var f=0; f<this.filters.interactions.facets.length; f++){
                  var facet_name = this.filters.interactions.facets[f].short
                  var entities = []
                  // For named entities
                  if (facet_name in document){
                      if (document[facet_name].preferred_term != ""){
                          entities.push(document[facet_name].preferred_term)
                      }
                  }
                  var sub_facet_name = facet_name+"1"
                  if (sub_facet_name in document){
                      if (document[sub_facet_name].preferred_term != ""){
                          entities.push(document[sub_facet_name].preferred_term)
                      }
                  }
                  sub_facet_name = facet_name+"2"
                  if (sub_facet_name in document){
                      if (document[sub_facet_name].preferred_term != ""){
                          entities.push(document[sub_facet_name].preferred_term)
                      }
                  }
                  // Remove duplicates
                  var entities_unique = [...new Set(entities)];
                  processed_facets[facet_name] = entities_unique
              }
            interactions[v].processed_facets = processed_facets
          }
          return interactions
        },
      removeFilter(facet_name, value){
          this.$matomo?.trackEvent("Remove facet ", facet_name+": "+value);
          var facet_name_low = facet_name.toLowerCase()
          if (facet_name_low != "date"){
              var filter_list = this.user_selection.interactions.facets[facet_name_low]

              for (var i = 0; i < filter_list.length; i++ ) {
                 if (filter_list[i] == value) {
                   filter_list.splice(i, 1)
                 }
              }
              this.updateInteractionsFacet({'facet': facet_name_low, 'list': filter_list })
          }
          else{
              this.updateInteractionsFacet({'facet': 'date', 'list': this.filters.date })
          }

      },
      removeAllFilters(){
        this.$matomo?.trackEvent("Remove all facets", "all");
        for (var key in this.user_selection.interactions.facets){
          this.updateInteractionsFacet({'facet': key, 'list': [] })
        }
      }
    }
  }

</script>

<style scoped lang="scss">

.progress-container {
    text-align: center;
    width: 100%;
    padding: 50px;
  }

  .content-container {
      display: flex;
  }

  .facets-container {
      float: left;
      margin-right: 20px;
  }

  .full-container {
      width: 100%;
      margin: 0 auto;
  }

  .active-filters-container {
    text-align: left;
    margin-bottom: 10px;
  }

  .filter-name {
    background-color: #f2f2f2;
    border-radius: 10px;
    padding: 2px 10px;
    margin-right: 5px;
    font-size: 0.8em;
  }

  .filter-remove {
    color: #AAAAAA;
    border-right: 1px solid #AAAAAA;
    margin-right: 5px;
  }

  .filter-remove:hover {
    cursor:pointer;
    color: var(--color-main);
  }

  .filters-remove {
    padding: 2px 10px;
    margin-right: 5px;
    font-size: 0.8em;
  }
  .filters-remove:hover {
    cursor:pointer;
    color: var(--color-main);
  }

</style>
